import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { NEWORLEANS_REVIEWS } from "@/data/reviews/neworleans";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/neworleans")({
  component: CityLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("neworleans"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/neworleans" }],
  }),
});

function CityLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="neworleans"
        cityLabel="New Orleans"
        headline={"New Orleans\nSprinter Van Rentals"}
        intro="New Orleans groups of 12 to 15 travel in one van here — full luggage capacity included, handed over at MSY, French Quarter or wherever you are staying."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">The New Orleans Sprinter Fleet</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            New Orleans Sprinter van rentals, ready to book.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug={"neworleans" as never} />
      </section>

      <CityMap citySlug={"neworleans" as never} accent="#F97316" />
      <ReviewsSection city="neworleans" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="New Orleans" reviews={NEWORLEANS_REVIEWS} />
      <SprinterSpecsSection city="neworleans" accent="#F97316" />
      <FleetMeatSection city="neworleans" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="New Orleans" />
      <SeoLongform citySlug="neworleans" />
      <GeoAnswerBlock citySlug="neworleans" />
      <CityUseCases citySlug={"neworleans" as never} accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · New Orleans</p>
      </footer>
    </main>
  );
}
